module.exports = __webpack_public_path__ + "img/filterIcon.62441f3d.svg";